import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const AgendamentoMensageriaList = (props) => <DefaultDataTable data={props} />
